import { render, staticRenderFns } from "./GliDialog.vue?vue&type=template&id=4af12580&scoped=true"
import script from "./GliDialog.vue?vue&type=script&lang=js"
export * from "./GliDialog.vue?vue&type=script&lang=js"
import style0 from "./GliDialog.vue?vue&type=style&index=0&id=4af12580&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af12580",
  null
  
)

export default component.exports